/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton, Switch } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import {
  RoleResponse,
  useDeleteRoleByIdMutation,
  useLazyGetAllRolesQuery,
  useUpdateRoleByIdMutation,
} from "../../services/accessRole";
import { showError, showToast } from "../../constants/toasts";
import { useEffect, useState } from "react";
import { strict } from "assert";
import moment from "moment";
import { handleDelete } from "../../utils/commonFunctions";
import { ConfirmationModal } from "../../Modals/confirmationModal";

const RolesList = ({
  debouncedSearchTerm,
}: {
  debouncedSearchTerm: string;
}) => {
  const navigate = useNavigate();
  const [roles, setRoles] = useState<RoleResponse[]>([]);
  const [allRoles] = useLazyGetAllRolesQuery();
  const [deleteById] = useDeleteRoleByIdMutation();
  const [updateRole] = useUpdateRoleByIdMutation();
  const [openDelete, setOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [count, setCount] = useState(0);
  const [page, setPage] = useState<number>(1);
  const [isLoading, setIsLoading] = useState(false);

  const label = { inputProps: { "aria-label": "Switch demo" } };

  const getRoleList = async () => {
    const body = {
      page: 1,
      limit: 10,
      search: debouncedSearchTerm,
    };

    try {
      setIsLoading(true);
      let response;
      response = await allRoles(body).unwrap();

      if (response?.statusCode === 200) {
        setRoles(response?.data?.SubAdminAccess);
        setCount(response?.data?.count);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleStatus = async (id: string, status: boolean) => {
    const body = {
      isBlocked: !status,
    };

    try {
      setIsLoading(true);
      let response;
      response = await updateRole({ id, body }).unwrap();

      if (response?.statusCode === 200) {
        showToast("Role status updated successfully");

        //   navigate(-1);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setIsLoading(false);
      getRoleList();
    }
  };

  // const rows = roles
  const columns: GridColDef<(typeof roles)[number]>[] = [
    {
      flex: 2,
      minWidth: 180,
      field: "name",
      headerName: "Role Name",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div
            className="user_block click_action"
            onClick={() =>
              navigate(`/manage-subadmin/roles/detail/${row?._id}`)
            }
          >
            <p>
              <b>{row?.name}</b>
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "date",
      headerName: "Created Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <p>
            <b>{moment(row?.createdAt).format("YYYY-MM-DD")}</b>
          </p>
        );
      },
    },
    {
      flex: 1,
      minWidth: 100,
      field: "status",
      headerName: "Status",
      editable: false,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: ({ row }) => {
        return (
          <Switch
            {...label}
            checked={!row?.isBlocked}
            onChange={() => handleStatus(row?._id, row?.isBlocked)}
          />
        );
      },
    },
    {
      minWidth: 130,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton
                onClick={() =>
                  navigate(`/manage-subadmin/roles/detail/${row?._id}`)
                }
              >
                <img src="/static/images/eye_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() =>
                  navigate(`/manage-subadmin/roles/edit/${row._id}`, {
                    state: row,
                  })
                }
              >
                <img src="/static/images/edit2_icon.svg" alt="" />
              </IconButton>
            </Box>
            <Box>
              <IconButton
                onClick={() => {
                  setSelectedId(row?._id);
                  setOpenDelete(true);
                }}
              >
                <img src="/static/images/trash2_icon.svg" alt="" />
              </IconButton>
            </Box>
          </div>
        );
      },
    },
  ];
  let hidden = ["fullName"];

  useEffect(() => {
    getRoleList();
  }, [debouncedSearchTerm]);

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={roles}
          count={count}
          page={page}
          onPageChange={handlePageChange}
          loading={isLoading}
        />
      </div>
      <ConfirmationModal
        text="Are you sure to delete this role"
        openModal={openDelete}
        setOpenModal={setOpenDelete}
        handleSubmit={() => handleDelete(deleteById, selectedId, getRoleList)}
      />
    </>
  );
};

export default RolesList;
